<template>
  <div
    class="padding-y-4xl"
    style="background: var(--white)"
  >
    <div class="container">
      <div
        class="display-flex flex-row"
        style="gap: var(--grid-gutter-x-width)"
      >
        <div class="flex-grow-0 margin-right-xl">
          <wa-logo-flag logo-size="2xl" />
        </div>
        <div>
          <div class="row roomy laptop:align-middle">
            <div class="column-12 laptop:column-8">
              <h2 class="h3">Font Awesome</h2>
              <p class="line-length-2xl">
                Font Awesome is the world's most popular icon set and toolkit. Our latest release has
                <site-link :to="$search()">{{ $counts.icons.all.formatted }} icons</site-link>
                in {{ categoriesCount }} categories across {{ $counts.totalLatestStylesWithoutBrands }} styles (plus
                <site-link :to="$search({ iconCollections: ['brands'] })">brands</site-link>!), with even more on the way. Get icons into your projects fast
                with Font Awesome!
              </p>
            </div>
            <div class="column-12 margin-top-md laptop:column-4 laptop:text-right laptop:margin-top-0">
              <site-link
                :to="$search()"
                class="button margin-0"
                style="--link-decoration-style: none; --link-decoration-line: none; --tag-link-hover-color: var(--fa-navy)"
              >
                View All {{ $counts.icons.all.formatted }} Icons
                <font-awesome-icon
                  :icon="$v6.solid.faArrowRight"
                  fixed-width
                  class="margin-left-xs"
                />
              </site-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'FontAwesomeSummary',

    props: {
      categoriesCount: {
        type: Number,
        default: null
      },
      version: {
        type: Number,
        default: null
      }
    }
  }
</script>
